import { NuevoUsuarioViewModel } from '../../models/viewmodels/UsuarioViewmodel';
import { ClienteViewModel } from '../../models/viewmodels/ClienteViewModel';
import { UsuarioService } from '../../services/usuario.service';
import { ClienteService } from '../../services/cliente.service';
import { Router, ActivatedRoute } from '@angular/router';
var RegistroUsuarioComponent = /** @class */ (function () {
    function RegistroUsuarioComponent(usuarioService, clienteService, router, route) {
        var _this = this;
        this.usuarioService = usuarioService;
        this.clienteService = clienteService;
        this.router = router;
        this.route = route;
        this.usuario = new NuevoUsuarioViewModel();
        this.cliente = new ClienteViewModel();
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.errores = new Array();
        this.sub = this.route.params.subscribe(function (params) {
            _this.cliente.id = params['id'];
            if (!_this.cliente.id) {
                _this.router.navigate(['login']);
                return;
            }
            _this.usuario.clientes = new Array();
            _this.usuario.clientes.push(_this.cliente);
            _this.clienteService.obtenerEmail(_this.cliente.id).subscribe(function (res) {
                _this.usuario.userName = res.text().replace(/\"/g, '');
                if (!_this.usuario.userName) {
                    _this.router.navigate(['login']);
                    return;
                }
            });
        });
    }
    RegistroUsuarioComponent.prototype.ngOnInit = function () {
        this.spinner.isRunning = false;
    };
    RegistroUsuarioComponent.prototype.onSubmit = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.alert.visible = false;
        this.usuario.recibeComprobantes = true;
        this.usuarioService.guardar(this.usuario)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Nuevo usuario";
            if (result.status == 201) {
                _this.router.navigate(['login']);
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "El usuario no se ha podido crear. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Nuevo usuario";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "El usuario no se ha podido crear. Por favor vuelva a intentarlo.";
            if (json.message) {
                var errores = json.message.replace(/\"/g, '').replace(/\[/g, '').replace(/\]/g, '').split(',');
                _this.errores = errores;
            }
            else if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    RegistroUsuarioComponent.ctorParameters = function () { return [{ type: UsuarioService }, { type: ClienteService }, { type: Router }, { type: ActivatedRoute }]; };
    return RegistroUsuarioComponent;
}());
export { RegistroUsuarioComponent };
//# sourceMappingURL=registro-usuario.component.js.map


// WEBPACK FOOTER //
// registro-usuario.component.js